import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../config';

const TEXT = {
  es: {
    loading: 'Confirmando tu nuevo email...',
    doneTitle: '\u00a1Email cambiado!',
    doneText: 'A partir de ahora inicia sesi\u00f3n con tu nuevo email. Tu contrase\u00f1a no ha cambiado.',
    errorTitle: 'No se pudo confirmar el cambio',
    missing: 'Falta el c\u00f3digo de confirmaci\u00f3n en el enlace.',
    genericError: 'Ha ocurrido un error. Vuelve a pedir el cambio desde Configuraci\u00f3n.',
    goToApp: 'Ir a la app',
  },
  en: {
    loading: 'Confirming your new email...',
    doneTitle: 'Email changed!',
    doneText: 'From now on, log in with your new email. Your password has not changed.',
    errorTitle: 'The change could not be confirmed',
    missing: 'The confirmation code is missing from the link.',
    genericError: 'Something went wrong. Request the change again from Settings.',
    goToApp: 'Go to the app',
  },
  fr: {
    loading: 'Confirmation de votre nouvel e-mail...',
    doneTitle: 'E-mail modifi\u00e9 !',
    doneText: 'D\u00e9sormais, connectez-vous avec votre nouvel e-mail. Votre mot de passe n\u2019a pas chang\u00e9.',
    errorTitle: 'Le changement n\u2019a pas pu \u00eatre confirm\u00e9',
    missing: 'Le code de confirmation manque dans le lien.',
    genericError: 'Une erreur est survenue. Refaites la demande depuis Param\u00e8tres.',
    goToApp: 'Aller \u00e0 l\u2019application',
  },
};

const getText = (lang) => TEXT[(lang || 'es').slice(0, 2)] || TEXT.es;

function ConfirmEmail() {
  const { i18n } = useTranslation();
  const tx = getText(i18n.language);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [state, setState] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setState('error');
      setMessage(tx.missing);
      return;
    }
    axios
      .post(`${API_URL}/api/v1/account/confirm-email`, { token })
      .then(() => setState('done'))
      .catch((err) => {
        const detail = err.response && err.response.data && err.response.data.detail;
        setState('error');
        setMessage(typeof detail === 'string' ? detail : tx.genericError);
      });
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="bg-panel min-h-screen flex items-center justify-center px-4 font-sans">
      <div className="bg-surface border border-edge rounded-2xl p-8 max-w-md w-full text-center">
        <h1 className="text-accent text-xl font-extrabold mb-5">Flash Multiservice</h1>
        {state === 'loading' && <p className="text-muted text-sm">{tx.loading}</p>}
        {state === 'done' && (
          <>
            <p className="text-white text-base font-semibold mb-2">{tx.doneTitle}</p>
            <p className="text-muted text-sm mb-6">{tx.doneText}</p>
          </>
        )}
        {state === 'error' && (
          <>
            <p className="text-red-400 text-base font-semibold mb-2">{tx.errorTitle}</p>
            <p className="text-muted text-sm mb-6">{message}</p>
          </>
        )}
        {state !== 'loading' && (
          <Link to="/dashboard" className="inline-block bg-accent text-panel font-bold text-sm px-5 py-2.5 rounded-lg">
            {tx.goToApp}
          </Link>
        )}
      </div>
    </div>
  );
}

export default ConfirmEmail;